import type { IconDefinition } from '../../types'

export default {
  details: [320, 512, [], '', 'M192 256c0 17.7-14.3 32-32 32s-32-14.3-32-32 14.3-32 32-32 32 14.3 32 32zm88-32c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32zm-240 0c-17.7 0-32 14.3-32 32s14.3 32 32 32 32-14.3 32-32-14.3-32-32-32z'],
  name: 'uiEllipsisH',
  oldName: 'falEllipsisH'
} as IconDefinition
